// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6f1df2d","239":"63f5c490","384":"2a06c9bd","455":"39fcac28","524":"98a9a992","600":"d0799952","705":"6a882578","722":"c7a35cc9","798":"9d9f86a0","839":"54ded066","899":"6482aade","922":"15ea7fca"}[chunkId] + ".chunk.js";
};